import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Query, useMutation, Subscription } from 'react-apollo';
import { Link, Route, Switch } from 'react-router-dom';
import Helmet from 'react-helmet/es/Helmet';
import { Formik, Form, Field, FieldArray } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import MaterialTable from 'material-table';
import Checkbox from '@material-ui/core/Checkbox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Drawer from '@material-ui/core/Drawer';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Spin from 'components/common/Spin';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';
import CloseIcon from '@material-ui/icons/Close';
import {
  ADD_CAMPAIGN,
  UPDATE_CAMPAIGN,
  SUBSCRIBE_GET_USERS,
  UPDATE_COMM_SETTINGS,
} from 'graphql/campaigns';
import useSnack from 'hooks/useSnack';
import { USER_TYPES } from 'constant/userTypes';

const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    width: 700,
    padding: theme.spacing(2),
  },
  close: {
    position: 'absolute',
    right: 10,
    top: 10,
  },
}));

const Optout = ({ history }) => {
  const classes = useStyles();
  const [updateSettings] = useMutation(UPDATE_COMM_SETTINGS);
  const [query, setQuery] = useState('');

  const onClose = () => history.goBack();

  const onToggleOptout = (user) => async (e) => {
    const { checked } = e.target;
    await updateSettings({
      variables: {
        userId: user.user_id,
        opted: !checked,
      },
    });
  };

  const columns = [
    {
      title: 'Name',
      field: 'name',
      render: (row) => `${row.name} ${row.user_last_name}`,
    },
    {
      title: 'Opt Out',
      align: 'right',
      render: (u) => (
        <Checkbox
          checked={u.notifications_settings[0]?.email === false}
          onChange={onToggleOptout(u)}
        />
      ),
    },
  ];

  const parentColumns = [

  ]

  return (
    <Drawer
      open
      anchor="right"
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <Box mb={3}>
        <Typography variant="h4">Optout</Typography>
        <IconButton onClick={onClose} className={classes.close}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Subscription subscription={SUBSCRIBE_GET_USERS}>
        {({ data, loading }) => {
          console.log(data)
          return (
            <Box>
              <MaterialTable
                title={false}
                options={{
                  search: true,
                  pageSize: 10,
                  padding: 'dense'
                }}
                detailPanel={[
                  {
                    tooltip: 'Show Parents',
                    render: rowData => {
                      return (
                          <MaterialTable
                              options={{
                                toolbar: false,
                                paging: false,
                              }}
                              columns={columns}
                              data={rowData.student_guardians.map(i => i.guardian)}
                          />
                      )
                    },
                  },
                ]}
                columns={columns}
                data={data?.users}
                isLoading={loading}
              />
            </Box>
          );
        }}
      </Subscription>
    </Drawer>
  );
};

export default Optout;
